import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule } from '../../../icons/icons.module';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [IconsModule, TranslateModule],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent {
  private location: Location = inject(Location);

  goBack() {
    this.location.back();
  }
}
